// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Container from '../components/Match/Overview/Container';
import { Redirect } from 'react-router-dom';

@inject('userStore')
@observer class MyMatchesRoute extends Component<any, any> {

	render() {
		if(this.props.userStore.user) {
			return (
				<Container key={this.props.userStore.user.id} />
			)
		} else {
			return (<Redirect to="/?login=true" />)
		}
	}
}

export default MyMatchesRoute;

